import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { SupportPlannerBO } from './supportplanner.model';


@Injectable({
  providedIn: 'root'
})
export class supportService {
  constructor(private http: HttpClient, public errorService: ErrorService, private handler: HttpBackend) { }

  save(saveContact: SupportPlannerBO): Observable<any> {
    let url = "api/SupportPlanner/SaveSupportPlanner";
    return this.http.post<any>(url, saveContact, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  delete(params: URLSearchParams) {
    let url = "api/SupportPlanner/DeleteSupportPlanner?";
    return this.http.delete<any>(url + params).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }


  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}